import { withRouter } from 'react-router';
import type { ConnectedProps } from './connectLanguageAndBrand';
import connectLanguageAndBrand from './connectLanguageAndBrand';
import type { LanguageAndBrandProps } from './LanguageAndBrand';
import LanguageAndBrand from './LanguageAndBrand';

export type ConnectedLanguageAndBrandProps = Omit<
    LanguageAndBrandProps,
    keyof ConnectedProps
>;

export default withRouter(connectLanguageAndBrand(LanguageAndBrand));
